import {
  Box,
  Button,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
// ADD BELOW 👇
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { url } from "../../src/utils/Constants";
import "./AnalyticsPage.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const AnalyticsPage = () => {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [monthView, setMonthView] = useState([]);
  const [open, setOpen] = useState(null);
  const [selectedBarData, setSelectedBarData] = useState(null);
  const baseUrl =
    "https://atci.lkm.vodafoneacademy.accenture.com/vodafone-apis";

  useEffect(() => {
    getAnalytics();
  }, [selectedYear]);

  // ================= API =================
  const getAnalytics = async () => {
    try {
      const response = await axios.post(
        `${url}/yearanalytics`,
        { year: selectedYear },
        {
          headers: {
            Authorization: sessionStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        },
      );

      // ✅ FIX 1: always set safe array
      setMonthView(Array.isArray(response?.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setMonthView([]); // ✅ FIX 2
    }
  };

  const downloadFile = async () => {
    try {
      const response = await axios.get(`${url}/downloadAnalytics`, {
        responseType: "blob",
        headers: {
          Authorization: sessionStorage.getItem("token"),
          //"Content-Type": "application/json",
        },
      });

      const responseUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");

      if (!link) {
        console.error("Error creating link element");
        return;
      }

      link.href = responseUrl;
      link.setAttribute("download", "data.xlsx");
      document.body.appendChild(link);

      if (typeof link.click !== "function") {
        console.error("Error: click() method not available");
        return;
      }

      link.click();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  // ================= DATA PROCESS =================
  const fillMissingMonths = () => {
    const safeMonthView = Array.isArray(monthView) ? monthView : [];

    return Array.from({ length: 12 }, (_, i) => {
      const month = i + 1;

      const monthData = safeMonthView
        .map((inner) =>
          Array.isArray(inner?.Data)
            ? inner.Data.filter((item) => item?.month === month)
            : [],
        )
        .flat();

      const totalViews = monthData.reduce(
        (acc, cur) => acc + (Number(cur?.total_views) || 0),
        0,
      );

      return {
        year: selectedYear,
        month,
        totalUniqueUsers: monthData.length,
        total_views: totalViews,
        total_views_by_enterprise: monthData.map((item) => ({
          enterprise_id: item?.enterprise_id || "",
          total_views: Number(item?.total_views) || 0,
        })),
      };
    });
  };

  // ✅ FIX 5: compute once (performance + stability)
  const filledData = fillMissingMonths();

  // ================= CHART CLICK =================
  const handleBarClick = (event) => {
    try {
      const activeElement = event?.chart?.getElementsAtEventForMode(
        event,
        "nearest",
        { intersect: true },
        true,
      )?.[0];

      if (!activeElement) return;

      const index = activeElement.index;

      // ✅ FIX 6: safe index check
      if (filledData[index]) {
        setSelectedBarData(filledData[index]);
        setOpen(index);
      } else {
        setSelectedBarData(null);
        setOpen(null);
      }
    } catch (err) {
      console.error("Chart click error:", err);
    }
  };

  // ================= CHART OPTIONS =================
  const options = {
    responsive: true,
    onClick: handleBarClick,
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Views",
          color: "grey",
          font: { weight: "bold" },
        },
      },
    },
    plugins: {
      legend: { position: "bottom" },
      title: {
        display: true,
        text: "Unique and Total Views Bar Chart",
        padding: 20,
        color: "#6e0089a6",
        font: { size: 20 },
      },
      datalabels: {
        color: "#6e0089",
        anchor: "end",
        align: "top",
        font: { weight: "bolder" },
      },
    },
  };

  const chartData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Unique Views",
        data: filledData.map((item) => item.totalUniqueUsers),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Total Views",
        data: filledData.map((item) => item.total_views),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  const handleCloseModal = () => {
    setOpen(null);
    setSelectedBarData(null); // ✅ FIX 7
  };

 

  return (
    <>
      {/* ================= MODAL ================= */}
      <Modal
        open={open !== null && selectedBarData !== null} // ✅ FIX 9
        onClose={handleCloseModal}
        className="custom-modal"
      >
        <Box className="tableWrapper">
          <TableContainer component={Paper} className="tableContainer">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Enterprise ID</TableCell>
                  <TableCell>Total Views</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedBarData?.total_views_by_enterprise?.map(
                  (item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.enterprise_id}</TableCell>
                      <TableCell>{item.total_views}</TableCell>
                    </TableRow>
                  ),
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>

      {/* ================= CONTROLS ================= */}
      <div id="date-picker-container">
        <Button onClick={downloadFile} size="small" variant="outlined">
          Download
        </Button>

        <DatePicker
          selected={new Date(selectedYear, 0, 1)}
          onChange={(date) =>
            setSelectedYear(date?.getFullYear?.() || selectedYear)
          } // ✅ FIX 10
          dateFormat="yyyy"
          showYearPicker
          className="yearPicker"
        />
      </div>

      {/* ================= CHART ================= */}
      <div className="bar-container">
        {filledData.length > 0 && ( // ✅ FIX 11
          <Bar plugins={[ChartDataLabels]} data={chartData} options={options} />
        )}
      </div>
    </>
  );
};

export default AnalyticsPage;
